export default (translation) => ({
  email: {
    required: true,
    email:true
  }
})